import { parseRegistrationDraft, RegistrationDraftData } from './registrationDraftSchema.ts';

const KEY = 'sminy:register:draft:v1';
export const REGISTRATION_DRAFT_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

/** Um único rascunho por navegador; links de administradores diferentes não se misturam. */
export function readRegistrationDraft(scope: string, storage?: Storage, now = Date.now()): RegistrationDraftData {
  try {
    const raw = (storage ?? window.localStorage).getItem(KEY);
    if (!raw) return {};
    const envelope = JSON.parse(raw);
    if (envelope?.version !== 1 || envelope.scope !== scope || typeof envelope.savedAt !== 'number' ||
        envelope.savedAt > now || now - envelope.savedAt > REGISTRATION_DRAFT_MAX_AGE) {
      (storage ?? window.localStorage).removeItem(KEY);
      return {};
    }
    return parseRegistrationDraft(envelope.data);
  } catch {
    return {};
  }
}

export function writeRegistrationDraft(scope: string, data: RegistrationDraftData, storage?: Storage, now = Date.now()): boolean {
  try {
    (storage ?? window.localStorage).setItem(KEY, JSON.stringify({ version: 1, scope, savedAt: now, data: parseRegistrationDraft(data) }));
    return true;
  } catch {
    return false;
  }
}

export function clearRegistrationDraft(storage?: Storage): void {
  try { (storage ?? window.localStorage).removeItem(KEY); } catch { /* O navegador pode bloquear o armazenamento. */ }
}
